module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_pos@2x.8f0eb5b1.png";